/**
 * One Idempotency-Key per logical mutation attempt.
 *
 * `ensure()` mints a key the first time it's called and returns the same key
 * on every subsequent call, so React Query's built-in retries of one
 * `mutate()` invocation reuse it. `reset()` clears it once that attempt
 * settles (success or final failure), so the next distinct user action
 * (clicking "guardar" again) gets a fresh key rather than silently
 * deduplicating against a different request.
 */
export type IdempotencyKeyHolder = {
  ensure: () => string;
  reset: () => void;
};

export function createIdempotencyKeyHolder(): IdempotencyKeyHolder {
  let key: string | null = null;
  return {
    ensure(): string {
      if (!key) key = crypto.randomUUID();
      return key;
    },
    reset(): void {
      key = null;
    },
  };
}
